import { Permission } from '@fabric-ui/components';
import { createFileRoute } from '@tanstack/react-router';
import { PAGE_PATHS } from '../../../../../types';
import Agents from '../../../../../views/Threat/Agents/Agents';

const path = PAGE_PATHS.AGENTS;

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/threats/agents/')({
  component: Agents,
  beforeLoad: ({ context, preload }) => {
    const isAllowed = context.userPermissions.hasAllowedPermission({ path, permission: Permission.READ });
    context.validatePermissions({ isAllowed, preload });
  },
});
